import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=faec4478"
import script from "./Lang.vue?vue&type=script&lang=js"
export * from "./Lang.vue?vue&type=script&lang=js"
import style0 from "./Lang.vue?vue&type=style&index=0&id=faec4478&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports